module.exports = __webpack_public_path__ + "static/menu-ru-ff8fd4e62484a479c4abc25711189dd5.jpg";